import { useState, useMemo, useLayoutEffect } from 'react';
import { ResizeObserver } from '@juggle/resize-observer';

function useContainerClientRect(containerId) {
  const [containerClientRect, setContainerClientRect] = useState();
  const observer = useMemo(() => {
    if (!containerId) return;
    const ResizeObserver$1 = window.ResizeObserver || ResizeObserver;
    return new ResizeObserver$1(entries => {
      if (entries[0]) {
        setContainerClientRect(entries[0].target.getBoundingClientRect());
      }
    });
  }, [containerId]);
  useLayoutEffect(() => {
    if (!containerId || !observer) return;
    const container = document.getElementById(containerId);
    if (container) {
      observer.observe(container);
    }
    return () => {
      observer.disconnect();
    };
  }, [containerId, observer]);
  return containerClientRect;
}

export { useContainerClientRect };
//# sourceMappingURL=useContainerClientRect.js.map
